import api from 'config/api.config';

export const globalInstagramSearch = async (query: string, type: string = 'user', social_media_account_id: any) => {
  try {
    const response: any = await api.post(
      `/api/instagram/search?query=${encodeURIComponent(query)}&type=${encodeURIComponent(type)}`,
      { social_media_account_id }
    );

    return response.data;
  } catch (error: any) {
    throw new Error(error.response?.data?.message || 'Failed to fetch Instagram search results');
  }
};

export default globalInstagramSearch;
